/* eslint-disable @typescript-eslint/naming-convention */
import * as t from "io-ts";

import { stringEnumCodec } from "../codecs";
import {
  initialReferringPageCodec,
  landingPageCodec,
  sharedDonationCodec,
} from "../codecs/cookies";

export enum UTM_QUERY_PARAM {
  utm_source = "utm_source",
  utm_medium = "utm_medium",
  utm_campaign = "utm_campaign",
  utm_term = "utm_term",
  utm_content = "utm_content",
}

export const UTM_QUERY_PARAM_TO_VAR_NAME = {
  [UTM_QUERY_PARAM.utm_source]: "utmSource",
  [UTM_QUERY_PARAM.utm_medium]: "utmMedium",
  [UTM_QUERY_PARAM.utm_campaign]: "utmCampaign",
  [UTM_QUERY_PARAM.utm_term]: "utmTerm",
  [UTM_QUERY_PARAM.utm_content]: "utmContent",
};

export const utmMetadataCodec = t.partial({
  utmCampaign: t.string,
  utmMedium: t.string,
  utmSource: t.string,
  utmTerm: t.string,
  utmContent: t.string,
});

export const signupMetadataCodec = t.partial({
  sharedDonation: sharedDonationCodec,
  initialReferrer: initialReferringPageCodec,
  landingPage: landingPageCodec,
});

export type UtmMetadata = t.TypeOf<typeof utmMetadataCodec>;

export enum DeviceType {
  iphone = "iphone",
  android = "android",
  desktop = "desktop",
  tablet = "tablet",
  unknown = "unknown",
}

export const analyticsCodec = t.partial({
  userAgent: t.string,
  device: stringEnumCodec({ name: "Device", enumObject: DeviceType }),
  paymentTab: t.string,
});

/**
 * Most of our event names are auto-generated based on tname, but this tracks
 * the names of events that we are tracking more explicitly.
 */
export enum CustomEvent {
  // Triggered when we show the donation modal
  DONATE_SHOW_MODAL = "DONATE_SHOW_MODAL",
  // Triggered when the user completes a donation -- see trackDonate
  DONATE = "DONATE",
  // Triggered when the user starts building their profile
  START_BUILD_PROFILE = "START_BUILD_PROFILE",
  // Triggered when the user completes building profile signs up -- see trackSignup
  USER_SIGN_UP = "USER_SIGN_UP",
  // Triggered when a user attempts to login -- see trackLoginAttempt
  USER_LOGIN_ATTEMPT = "USER_LOGIN_ATTEMPT",
  // Triggered when the user clicks a specific share button
  SHARE_BUTTON_CLICK = "SHARE_BUTTON_CLICK",
  // Triggered when the user clicks a button in a feed
  FEED_BUTTON_CLICK = "FEED_BUTTON_CLICK",
  // Triggered when the user submits a search using the search bar
  SUBMIT_SEARCH = "SUBMIT_SEARCH",
  // Triggered when the user clicks a suggestion via search
  SEARCH_SUGGESTION_CLICKED = "SEARCH_SUGGESTION_CLICKED",
  // Triggered when a user opens the notification drawer and views notifications
  NOTIFICATIONS_VIEWED = "NOTIFICATIONS_VIEWED",
  // Experiment triggered, new experimental event comparing to $experiment_started
  EXPERIMENT_TRIGGERED = "EXPERIMENT_TRIGGERED",
  SEARCH_EXACT_CAUSE = "SEARCH_EXACT_CAUSE",
  FREQUENCY_ERROR = "FREQUENCY_ERROR",
  FREQUENCY_SET = "FREQUENCY_SET",
  AMOUNT_ERROR = "AMOUNT_ERROR",
  DONATE_COMPLETED = "DONATE_COMPLETED",
  CONFIGURE_BUTTON_STARTED = "CONFIGURE_BUTTON_STARTED",
  DONATE_RECEIVED = "DONATE_RECEIVED",
  CONFIGURE_BUTTON_CREATED = "CONFIGURE_BUTTON_CREATED",
  CONFIGURE_BUTTON_COPIED = "CONFIGURE_BUTTON_COPIED",
  ADMIN_ACCEPTED = "ADMIN_ACCEPTED",
  // Donate button loaded in a website associated to admins and just to the nonprofit
  BUTTON_LOADED_ADMIN = "BUTTON_LOADED_ADMIN",
  BUTTON_LOADED_NONPROFIT = "BUTTON_LOADED_NONPROFIT",
  STRIPE_ACCEPTED = "STRIPE_ACCEPTED",
}
